// ============================================================
// VCS.DatingFindme — "Finde mich"-Spiel (Phase 2: warm/kalt + Pfeil)
// ============================================================
// Eigener Vollbild-Screen (#datingFindmeScreen), KEIN Overlay im Chat. Nur zwischen
// GEMATCHTEN Menschen und nur mit beidseitiger Freigabe (Einladung + Annahme). Der
// Standort geht als ROHE Position an den SERVER (nicht an den anderen Client) -- der
// Server rechnet Distanz/Richtung/Stufe und schickt nur das Ergebnis zurueck. Die echte
// Koordinate des anderen sieht man erst in der Nah-Stufe (<50 m), und dann gerundet.
//
// Das ist die EINE bewusste Ausnahme von "kein Standort/kein Marker": sie ist durch das
// Match + die aktive Freigabe gedeckt und zeitlich auf die Session begrenzt.
//
// WS-Protokoll (Server: signaling/main-server.js):
//   raus: findme-invite {toHandle} | findme-accept | findme-decline | findme-position | findme-end
//   rein: findme-invited {sessionId, fromHandle} | findme-accepted | findme-update | findme-ended | findme-busy
//
// Die Karte der Nah-Stufe kommt in Phase 3 -- hier steht dort erst ein Platzhalter.
// Konzept: dating_findme_spiel_plan.md.
// ============================================================
window.VCS = window.VCS || {};

VCS.DatingFindme = class {

    // Position hoechstens alle 3 s an den Server (Akku/Traffic). watchPosition feuert
    // oefter; dazwischen wird verworfen.
    static SEND_THROTTLE_MS = 3000;

    // Kachel-Quelle der Nah-Karte. Standard-OSM-Raster -- als EINE austauschbare Konstante,
    // damit spaeter leicht auf MapTiler o.ae. (mit API-Key) gewechselt werden kann. Nur die
    // Kacheln kommen extern; Leaflet selbst ist self-hosted (js/leaflet/, kein CDN).
    static TILE_URL = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';
    static TILE_ATTRIBUTION = '&copy; OpenStreetMap';

    // Radius des Unsicherheitskreises (m) um jeden Punkt. Der Server rundet die Positionen
    // ohnehin (~11 m); der Kreis zeigt "irgendwo hier", kein metergenauer Pin.
    static UNCERTAINTY_M = 20;

    // Glaettungsfaktor fuer die Kompass-Blickrichtung (0..1). Kleiner = ruhiger, aber traeger.
    static HEADING_SMOOTH = 0.2;

    constructor() {
        this._view = {
            screen: $('#datingFindmeScreen'),
            body  : $('#datingFindmeBody')
        };

        this._sessionId = '';
        this._role      = '';        // 'a' = Einladender, 'b' = Eingeladener
        this._peerName  = '';        // nur bekannt, wenn ich eingeladen habe
        this._status    = 'idle';    // idle | inviting | invited | active
        this._watchId   = 0;
        this._lastSend  = 0;
        this._last      = null;      // letztes findme-update (stage/trend/bearing/self/peer)
        this._map       = null;      // Leaflet-Instanz der Nah-Karte (nur waehrend Nah-Stufe)
        this._layers    = null;      // {self, peer} = {marker, circle} auf der Karte

        // Kompass (Fern-Stufe): Pfeil dreht sich mit der Geraete-Blickrichtung mit.
        this._heading              = null;   // geglaettete Blickrichtung (Grad), null = kein Kompass
        this._orientHandler        = null;   // deviceorientation-Listener (fuer sauberes Entfernen)
        this._compassActive        = false;
        this._compassNeedsPermission = false;   // iOS: erst nach requestPermission per Nutzergeste
        this._absSeen              = false;   // schon ein 'absolute'-Event gesehen? (Android)

        this._bind();
    }

    init() {}

    // ── Klicks im Screen (delegiert) ─────────────────────────
    _bind() {
        this._view.screen.on('click', '[data-findme]', (e) => {
            const action = $(e.currentTarget).attr('data-findme');
            if (action === 'accept')  { this.accept(); }
            else if (action === 'decline') { this.decline(); }
            else if (action === 'end') { this.end(); }
            else if (action === 'compass') { this._requestCompassPermission(); }
        });
    }

    // ── Einstieg: ich lade einen Match ein ───────────────────
    // Aufruf aus dem Match-Profil (dating-deck _showCandidate, match=true).
    invite(toHandle, name) {
        if (!toHandle) { return; }
        if (this._status !== 'idle') { return; }   // schon in einem Spiel
        if (!navigator.geolocation) {
            VCS.ui?.showToast?.(t('datingFindmeNoGeo'), 'error', 6000);
            return;
        }
        this._role     = 'a';
        this._peerName = name || '';
        this._status   = 'inviting';
        VCS.signaling?.send?.({ type: 'findme-invite', toHandle: toHandle });
        console.log('[findme] invite -> ' + toHandle);
        this._open();
        this._render();
    }

    // ── Eingehende WS-Nachrichten (aus signaling.js) ─────────
    onInvited(msg) {
        if (!msg || !msg.sessionId) { return; }
        // Laeuft schon ein Spiel, ignorieren wir die Einladung still -- der Server
        // haelt ohnehin nur eine Session pro Person.
        if (this._status !== 'idle') { return; }
        this._sessionId = msg.sessionId;
        this._role      = 'b';
        this._peerName  = this._nameForHandle(msg.fromHandle);
        this._status    = 'invited';
        console.log('[findme] invited von ' + (msg.fromHandle || '') + ' id=' + msg.sessionId.slice(0, 8));
        this._open();
        this._render();
    }

    // Der Server bestaetigt dem Einladenden die Session -- ab jetzt kennt A die sessionId
    // und kann abbrechen, auch bevor B angenommen hat.
    onPending(msg) {
        if (this._role === 'a' && this._status === 'inviting' && msg && msg.sessionId) {
            this._sessionId = msg.sessionId;
        }
    }

    onAccepted(msg) {
        if (this._role !== 'a' || this._status !== 'inviting') { return; }
        // Der Einladende bekommt die sessionId erst hier: der Server vergibt sie.
        if (msg && msg.sessionId) { this._sessionId = msg.sessionId; }
        this._status = 'active';
        console.log('[findme] accepted -> aktiv');
        this._startWatch();
        this._render();
    }

    onUpdate(msg) {
        if (this._status !== 'active' || !msg || msg.sessionId !== this._sessionId) { return; }
        this._last = msg;
        // Hot-Path Nah-Stufe (alle ~3 s): Karte NICHT neu bauen, nur Punkte verschieben.
        // Sonst wuerde jede Positions-Aktualisierung den WebGL-Kontext neu aufziehen.
        if (msg.stage === 'near' && this._map) {
            this._updateMap();
            return;
        }
        this._render();
    }

    onEnded(msg) {
        if (!msg || (this._sessionId && msg.sessionId !== this._sessionId)) { return; }
        console.log('[findme] ended reason=' + (msg && msg.reason));
        this._teardown();
        VCS.ui?.showToast?.(t('datingFindmeEnded'), 'info', 4000);
    }

    onBusy() {
        VCS.ui?.showToast?.(t('datingFindmeBusy'), 'info', 5000);
        // Kein aktiver eigener Zustand -> Screen wieder zu.
        if (this._status === 'inviting') { this._teardown(); }
    }

    // Nach einem Reconnect kennt der neue Socket die Session nicht mehr -> sauber beenden.
    onSocketAuthed() {
        if (this._status === 'active' || this._status === 'inviting' || this._status === 'invited') {
            this._teardown();
        }
    }

    // ── Aktionen des Nutzers ─────────────────────────────────
    accept() {
        if (this._role !== 'b' || this._status !== 'invited') { return; }
        this._status = 'active';
        VCS.signaling?.send?.({ type: 'findme-accept', sessionId: this._sessionId });
        console.log('[findme] accept -> aktiv');
        this._startWatch();
        this._render();
    }

    decline() {
        if (this._sessionId) {
            VCS.signaling?.send?.({ type: 'findme-decline', sessionId: this._sessionId });
        }
        console.log('[findme] decline');
        this._teardown();
    }

    end() {
        if (this._sessionId) {
            VCS.signaling?.send?.({ type: 'findme-end', sessionId: this._sessionId });
        }
        console.log('[findme] end');
        this._teardown();
    }

    // ── Standort (roh, nur an den Server) ────────────────────
    _startWatch() {
        this._startCompass();   // Kompass fuer die Pfeil-Drehung in der Fern-Stufe
        if (this._watchId || !navigator.geolocation) { return; }
        this._lastSend = 0;
        this._watchId = navigator.geolocation.watchPosition(
            (pos) => {
                const now = Date.now();
                if (now - this._lastSend < VCS.DatingFindme.SEND_THROTTLE_MS) { return; }
                this._lastSend = now;
                VCS.signaling?.send?.({
                    type: 'findme-position',
                    sessionId: this._sessionId,
                    lat: pos.coords.latitude,
                    lng: pos.coords.longitude,
                    acc: Math.round(pos.coords.accuracy || 0)
                });
            },
            (e) => {
                // Zwischendurch-Fehler (kein Fix) nicht abbrechen -- danach kommen wieder
                // Positionen. Nur beim harten Verbot beenden.
                console.warn('[findme] watch: code=' + (e && e.code));
                if (e && e.code === 1) {   // PERMISSION_DENIED
                    VCS.ui?.showToast?.(t('datingFindmeNoGeo'), 'error', 6000);
                    this.end();
                }
            },
            VCS.DatingGeo.GEO_OPTIONS
        );
    }

    _stopWatch() {
        if (this._watchId && navigator.geolocation) {
            navigator.geolocation.clearWatch(this._watchId);
        }
        this._watchId = 0;
    }

    // ── Kompass (Fern-Stufe: Pfeil dreht mit der Geraete-Blickrichtung) ──
    // Pfeil-Rotation = (bearing - heading + 360) % 360. bearing kommt vom Server, heading
    // vom Kompass. Ohne Kompass/ohne Freigabe/Desktop -> Pfeil zeigt den absoluten bearing.
    _startCompass() {
        if (this._compassActive) { return; }
        const DOE = window.DeviceOrientationEvent;
        if (!DOE) { return; }   // kein Sensor -> Fallback bearing
        if (typeof DOE.requestPermission === 'function') {
            // iOS 13+: Listener erst nach requestPermission() per Nutzergeste -> Button zeigen.
            this._compassNeedsPermission = true;
            return;
        }
        this._attachOrient();   // Android/Desktop: direkt anhaengen
    }

    // Ausgeloest vom "Kompass aktivieren"-Button (Nutzergeste, iOS-Pflicht).
    _requestCompassPermission() {
        const DOE = window.DeviceOrientationEvent;
        if (!DOE || typeof DOE.requestPermission !== 'function') { this._attachOrient(); return; }
        DOE.requestPermission().then((res) => {
            if (res === 'granted') {
                this._compassNeedsPermission = false;
                this._attachOrient();
                this._render();   // Button entfernen, Pfeil ab jetzt kompass-gedreht
            } else {
                console.log('[findme] compass permission: ' + res);
            }
        }).catch((err) => { console.warn('[findme] compass permission error', err); });
    }

    _attachOrient() {
        if (this._compassActive) { return; }
        this._orientHandler = (e) => this._onOrient(e);
        // 'absolute' zuerst (Android liefert dort echten Nord-Bezug), 'deviceorientation' als Fallback.
        window.addEventListener('deviceorientationabsolute', this._orientHandler, true);
        window.addEventListener('deviceorientation', this._orientHandler, true);
        this._compassActive = true;
    }

    _onOrient(e) {
        const isAbs = (e.type === 'deviceorientationabsolute') || e.absolute === true;
        if (isAbs) { this._absSeen = true; }
        let heading = null;
        if (typeof e.webkitCompassHeading === 'number' && !isNaN(e.webkitCompassHeading)) {
            heading = e.webkitCompassHeading;          // iOS: 0 = Norden, im Uhrzeigersinn
        } else if (typeof e.alpha === 'number') {
            // Nur die absolute (nordbezogene) Quelle nutzen. Das relative 'deviceorientation'
            // ignorieren, sobald eine absolute Quelle da ist -- sonst zeigt der Pfeil falsch.
            if (!isAbs && this._absSeen) { return; }
            heading = (360 - e.alpha) % 360;           // Android: alpha -> Kompass-Heading
        }
        if (heading === null || isNaN(heading)) { return; }
        this._heading = this._smoothHeading(heading);
        this._applyArrowRotation();
    }

    // Gleitender Mittelwert mit 0/360-Wraparound (ueber die kuerzeste Winkeldifferenz).
    _smoothHeading(h) {
        if (this._heading === null) { return h; }
        const diff = ((h - this._heading + 540) % 360) - 180;
        return (this._heading + VCS.DatingFindme.HEADING_SMOOTH * diff + 360) % 360;
    }

    // Pfeil-Winkel: mit Kompass relativ zur Blickrichtung, sonst absoluter bearing (Fallback).
    _arrowDeg() {
        const bearing = this._last ? (this._last.bearing || 0) : 0;
        if (this._heading === null) { return Math.round(bearing); }
        return Math.round((bearing - this._heading + 360) % 360);
    }

    // Live-Rotation direkt am SVG (kein DOM-Rebuild). Nur in der Fern-Stufe relevant.
    _applyArrowRotation() {
        const u = this._last;
        if (!u || u.stage === 'near') { return; }
        const arrow = this._view.body.find('.dating-findme-arrow').get(0);
        if (!arrow) { return; }
        // Bei aktivem Kompass kurze Transition (JS glaettet schon), sonst die CSS-Vorgabe (0.6s).
        if (this._heading !== null) { arrow.style.transition = 'transform 0.15s linear'; }
        arrow.style.transform = 'rotate(' + this._arrowDeg() + 'deg)';
    }

    _stopCompass() {
        if (this._orientHandler) {
            window.removeEventListener('deviceorientationabsolute', this._orientHandler, true);
            window.removeEventListener('deviceorientation', this._orientHandler, true);
            this._orientHandler = null;
        }
        this._compassActive = false;
        this._compassNeedsPermission = false;
        this._absSeen = false;
        this._heading = null;
    }

    // ── Screen ───────────────────────────────────────────────
    _open()  { this._view.screen.removeClass('hidden'); }
    _close() { this._view.screen.addClass('hidden'); }

    _teardown() {
        this._stopWatch();
        this._stopCompass();
        this._destroyMap();
        this._close();
        this._sessionId = '';
        this._role      = '';
        this._peerName  = '';
        this._status    = 'idle';
        this._last      = null;
        this._view.body.empty();
    }

    // ── Nah-Karte (Leaflet, nur waehrend der Nah-Stufe) ─────────
    // Wir zeichnen NUR die vom Server gelieferten, bereits gerundeten Punkte self/peer.
    // Keine eigene Roh-Position, kein Live-Tracking ueber die Session hinaus.
    _initMap() {
        const el = document.getElementById('datingFindmeMap');
        if (!el || !window.L) {
            if (!window.L) { console.warn('[findme] Leaflet nicht geladen'); }
            return;
        }
        this._destroyMap();   // alte Instanz (falls DOM neu aufgebaut wurde) freigeben
        this._map = L.map(el, { attributionControl: true, zoomControl: false });
        L.tileLayer(VCS.DatingFindme.TILE_URL, {
            maxZoom    : 19,
            attribution: VCS.DatingFindme.TILE_ATTRIBUTION
        }).addTo(this._map);
        // Leaflet muss seine Groesse kennen, sobald der Container sichtbar ist.
        setTimeout(() => { try { this._map && this._map.invalidateSize(); } catch (e) {} }, 0);
    }

    _updateMap() {
        const u = this._last;
        if (!this._map || !u || !u.self || !u.peer) { return; }
        // Namensschilder statt Punkte -- sonst weiss man nicht, wer wer ist.
        // Peer zuerst, damit "Du" bei Ueberlappung oben liegt.
        this._setPoint('peer', u.peer, '#4a90d9', this._peerName || t('datingFindmeYourMatch'));   // Kuehl-Blau
        this._setPoint('self', u.self, '#f97316', t('you'));   // accent (orange)
        // Bildausschnitt auf beide Punkte fitten (bei Deckungsgleichheit greift maxZoom).
        // Oben mehr Rand, weil die Schilder ueber den Punkten stehen.
        const bounds = L.latLngBounds(
            [u.self.lat, u.self.lng],
            [u.peer.lat, u.peer.lng]);
        this._map.fitBounds(bounds, { paddingTopLeft: [50, 70], paddingBottomRight: [50, 30], maxZoom: 18 });
    }

    // Punkt = Namensschild + Unsicherheitskreis (in Metern). Beim Update nur die Position
    // verschieben, nicht neu anlegen -- kein Flackern im ~3-s-Takt.
    _setPoint(kind, pt, color, label) {
        if (!this._layers) { this._layers = {}; }
        const ll = [pt.lat, pt.lng];
        let l = this._layers[kind];
        if (!l) {
            const circle = L.circle(ll, {
                radius: VCS.DatingFindme.UNCERTAINTY_M,
                color: color, weight: 1.5, opacity: 0.6, fillColor: color, fillOpacity: 0.15
            }).addTo(this._map);
            // Schild ueber dem Punkt: iconAnchor = Mitte unten -> Spitze sitzt auf der Position.
            const icon = L.divIcon({
                className : 'dating-findme-pin',
                iconSize  : [150, 40],
                iconAnchor: [75, 40],
                html      : '<div class="dating-findme-pin-inner" style="color:' + color + '">'
                          + '<div class="dating-findme-pin-label" style="background:' + color + '">'
                          + escapeHtml(label) + '</div>'
                          + '<div class="dating-findme-pin-tip"></div>'
                          + '</div>'
            });
            const marker = L.marker(ll, { icon: icon, interactive: false, keyboard: false })
                .addTo(this._map);
            this._layers[kind] = { circle: circle, marker: marker };
        } else {
            l.circle.setLatLng(ll);
            l.marker.setLatLng(ll);
        }
    }

    _destroyMap() {
        this._layers = null;   // Layer haengen an der Map -> mit map.remove() weg
        if (this._map) { try { this._map.remove(); } catch (e) {} this._map = null; }
    }

    // Name eines Match-Handles aus der schon geladenen Match-Liste (VCS.dating). Nicht
    // kritisch -- fehlt er, zeigt der Screen einen neutralen Text.
    _nameForHandle(handle) {
        const list = VCS.dating?.matches?.() || [];
        const m = list.find((x) => x.handle === handle);
        return (m && m.displayName) || '';
    }

    _render() {
        const b = this._view.body;
        if (this._status === 'inviting') {
            b.html(this._stateHtml(
                t('datingFindmeTitle'),
                this._peerName ? t('datingFindmeInviting').replace('{0}', escapeHtml(this._peerName))
                               : t('datingFindmeInvitingGeneric'),
                [{ action: 'end', label: t('datingFindmeCancel'), kind: 'ghost' }]));
            return;
        }
        if (this._status === 'invited') {
            b.html(this._stateHtml(
                t('datingFindmeTitle'),
                this._peerName ? t('datingFindmeInvite').replace('{0}', escapeHtml(this._peerName))
                               : t('datingFindmeInviteGeneric'),
                [{ action: 'accept',  label: t('datingFindmeAccept'),  kind: 'primary' },
                 { action: 'decline', label: t('datingFindmeDecline'), kind: 'ghost' }]));
            return;
        }
        if (this._status === 'active') {
            const near = !!(this._last && this._last.stage === 'near');
            if (!near) { this._destroyMap(); }   // zurueck aus der Nah-Stufe -> Karte weg
            b.html(this._activeHtml());
            if (near) { this._initMap(); this._updateMap(); }
            else { this._applyArrowRotation(); }   // aktuelle Kompass-Drehung nach Rebuild anwenden
            return;
        }
        b.empty();
    }

    // Einfache Zustands-Ansicht (Einladung/Warten) -- nutzt die vorhandenen dating-state-Klassen.
    _stateHtml(title, body, buttons) {
        const btns = (buttons || []).map((x) =>
            '<button type="button" class="dating-findme-btn dating-findme-btn--' + x.kind
            + '" data-findme="' + x.action + '">' + escapeHtml(x.label) + '</button>').join('');
        return '<div class="dating-findme-inner">'
            + '<h2 class="dating-findme-title">' + escapeHtml(title) + '</h2>'
            + '<p class="dating-findme-text">' + body + '</p>'
            + '<div class="dating-findme-actions">' + btns + '</div>'
            + '</div>';
    }

    // Aktives Spiel: grosser Richtungspfeil + warm/kalt. In der Fern-Stufe dreht der Pfeil mit
    // dem Kompass mit (zeigt real "da lang"); ohne Kompass den absoluten bearing. Nah-Stufe: Karte.
    _activeHtml() {
        const u = this._last;
        const near = u && u.stage === 'near';
        let center;
        if (!u) {
            center = '<div class="dating-findme-hunt">' + escapeHtml(t('datingFindmeSearching')) + '</div>';
        } else if (u.stage === 'too_far') {
            // Zu weit auseinander -- kein Pfeil, kein Kompass. Nur der Hinweis; das Spiel
            // bleibt aktiv und springt zurueck, sobald ihr wieder naeher kommt.
            center = '<div class="dating-findme-hunt dating-findme-toofar">'
                + escapeHtml(t('datingFindmeTooFar')) + '</div>';
        } else if (near) {
            // Nah-Stufe: Karte mit beiden Punkten (self/peer) + Unsicherheitskreis. Der
            // Container wird nach dem Einfuegen von _initMap()/_updateMap() befuellt.
            center = '<div class="dating-findme-map-wrap">'
                + '<div class="dating-findme-near-text">' + escapeHtml(t('datingFindmeNear')) + '</div>'
                + '<div id="datingFindmeMap" class="dating-findme-map"></div>'
                + '</div>';
        } else {
            const deg = this._arrowDeg();   // mit Kompass relativ zur Blickrichtung, sonst bearing
            const trend = u.trend === 'warmer' ? t('datingFindmeWarmer')
                        : u.trend === 'colder' ? t('datingFindmeColder')
                        : t('datingFindmeSearching');
            // iOS: Kompass braucht eine Nutzergeste -> Aktivier-Button, danach faellt er weg.
            const compassBtn = (this._compassNeedsPermission && !this._compassActive)
                ? '<button type="button" class="dating-findme-btn dating-findme-btn--ghost dating-findme-compass" '
                  + 'data-findme="compass">' + escapeHtml(t('datingFindmeCompass')) + '</button>'
                : '';
            center = '<div class="dating-findme-arrow-wrap">'
                + '<svg class="dating-findme-arrow" style="transform:rotate(' + deg + 'deg)" '
                + 'viewBox="0 0 24 24" width="120" height="120" fill="currentColor">'
                + '<path d="M12 2l7 18-7-4-7 4z"></path></svg>'
                + '<div class="dating-findme-trend dating-findme-trend--' + (u.trend || 'same') + '">'
                + escapeHtml(trend) + '</div>'
                + compassBtn
                + '</div>';
        }
        return '<div class="dating-findme-inner">'
            + '<h2 class="dating-findme-title">' + escapeHtml(t('datingFindmeTitle')) + '</h2>'
            + center
            + '<p class="dating-findme-hint">' + escapeHtml(t('datingFindmeHint')) + '</p>'
            + '<div class="dating-findme-actions">'
            + '<button type="button" class="dating-findme-btn dating-findme-btn--danger" data-findme="end">'
            + escapeHtml(t('datingFindmeEnd')) + '</button>'
            + '</div></div>';
    }
};
